import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Paper,
    Typography,
    Button,
    Box,
    Avatar,
    Divider,
    Link
} from '@mui/material';
import {
    CheckCircle as CheckCircleIcon,
    Home as HomeIcon,
    Person as PersonIcon,
    Cancel as CancelIcon,
    Payment as PaymentIcon,
} from '@mui/icons-material';
import { CheckoutSuccess } from 'components/logic/paymentgateway/CheckoutSuccess';


const SuccessPage = () => {
    const navigate = useNavigate();
    const sessionId = new URLSearchParams(window.location.search).get('session_id');
    const [isPaid, setIsPaid] = useState(false);
    const [isfailed, setIsFailed] = useState(false);

    const VerifyCheckout = async (sessionId) => {
        try {
            const response = await CheckoutSuccess(sessionId);
            if (!response.isError && response.message.toLowerCase() === "payment processed successfully.") {
                setIsPaid(true);
            } else {
                setIsFailed(true);
            }
        } catch (error) {
            console.error("Error verifying checkout:", error);
        }
    }
    useEffect(() => {
        if (sessionId == null || sessionId === undefined) {
            console.warn("Session ID is missing. Redirecting to home page.");
            navigate('/');
        } else {
            VerifyCheckout(sessionId);
        }
    }, [sessionId]);

    const Success = () => {
        return (
            <Container maxWidth="sm" sx={{ py: 4 }}>
                <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                        <Avatar sx={{ bgcolor: 'success.light', width: 80, height: 80 }}>
                            <CheckCircleIcon sx={{ fontSize: 48 }} />
                        </Avatar>
                    </Box>

                    <Typography variant="h4" gutterBottom>
                        Payment Successful!
                    </Typography>
                    <Typography variant="body1" color="text.secondary" gutterBottom>
                        Thank you for your purchase. Your payment has been processed successfully.
                        A receipt has been sent to your email.
                    </Typography>

                    <Box sx={{ mt: 4, '& > *': { mb: 2 } }}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="success"
                            size="large"
                            onClick={() => navigate('/')}
                            startIcon={<HomeIcon />}
                            sx={{ mb: 2 }}
                        >
                            Return to Dashboard
                        </Button>

                        <Button
                            fullWidth
                            variant="outlined"
                            color="success"
                            size="large"
                            onClick={() => navigate('/settings#5')}
                            startIcon={<PersonIcon />}
                        >
                            View Subscription Details
                        </Button>
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    {/* <Typography variant="body2" color="text.secondary">
                        Need help? <Link href="mailto:support@cleri.ai">Contact support</Link>
                    </Typography> */}
                </Paper>
            </Container>
        );
    }
    const Failed = () => {
        return (
            <Container maxWidth="sm" sx={{ py: 4 }}>
                <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                        <Avatar sx={{ bgcolor: 'error.light', width: 80, height: 80 }}>
                            <CancelIcon sx={{ fontSize: 48 }} />
                        </Avatar>
                    </Box>
                    <Typography variant="h4" gutterBottom>
                        Payment Failed
                    </Typography>
                    <Typography variant="body1" color="text.secondary" gutterBottom>
                        Your payment was not completed. You can try again or choose a different payment method.
                    </Typography>

                    <Box sx={{ mt: 4, '& > *': { mb: 2 } }}>
                        {/* <Button
                            fullWidth
                            variant="contained"
                            color="error"
                            size="large"
                            onClick={() => navigate('/checkout')}
                            startIcon={<PaymentIcon />}
                            sx={{ mb: 2 }}
                        >
                            Try Again
                        </Button> */}

                        <Button
                            fullWidth
                            variant="outlined"
                            color="error"
                            size="large"
                            onClick={() => navigate('/')}
                            startIcon={<HomeIcon />}
                        >
                            Return to Dashboard
                        </Button>
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    {/* <Typography variant="body2" color="text.secondary">
                        Having trouble? <Link href="mailto:support@cleri.ai">Contact support</Link>
                    </Typography> */}
                </Paper>
            </Container>
        );
    }
    return (
        <>
            {isPaid && (<Success />)}
            {isfailed && (<Failed/>)}            
        </>        
    );
};

export default SuccessPage;